import { render } from "./clinical_reports_index.vue?vue&type=template&id=770de5c5&scoped=true"
import script from "./clinical_reports_index.vue?vue&type=script&lang=js"
export * from "./clinical_reports_index.vue?vue&type=script&lang=js"

import "./clinical_reports_index.vue?vue&type=style&index=0&id=770de5c5&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-770de5c5"]])

export default __exports__